import React from "react"
import PropTypes from "prop-types"
import Styles from "./PersonnelInfos.module.css"
import RibbonContainer from "../RibbonContainer"
import { Select } from "../Select"

const Cell = ({ header, text }) => (
  <div className={Styles.cell}>
    <p className={Styles.header}>{header}</p>
    <p className={Styles.huge}>{text}</p>
  </div>
)

Cell.propTypes = {
  header: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

const PersonnelInfos = ({
  allPersonnelInfos,
  selectedYear,
  yearOptions,
  onChange
}) => {
  const personnelInfos = allPersonnelInfos?.[selectedYear?.value]
  const hasSomeEmployees = personnelInfos?.hlokeskim_total > 0

  if (!personnelInfos || !hasSomeEmployees) {
    return null
  }

  const municipalitiesWithEmployees = [
    personnelInfos?.hlokeskim_tampere > 0 ? { name: "Tampere", employees: personnelInfos?.hlokeskim_tampere } : null,
    personnelInfos?.hlokeskim_kangasala > 0 ? { name: "Kangasala", employees: personnelInfos?.hlokeskim_kangasala } : null,
    personnelInfos?.hlokeskim_lempaala > 0 ? { name: "Lempäälä", employees: personnelInfos?.hlokeskim_lempaala } : null,
    personnelInfos?.hlokeskim_nokia > 0 ? { name: "Nokia", employees: personnelInfos?.hlokeskim_nokia } : null,
    personnelInfos?.hlokeskim_orivesi > 0 ? { name: "Orivesi", employees: personnelInfos?.hlokeskim_orivesi } : null,
    personnelInfos?.hlokeskim_pirkkala > 0 ? { name: "Pirkkala", employees: personnelInfos?.hlokeskim_pirkkala } : null,
    personnelInfos?.hlokeskim_vesilahti > 0 ? { name: "Vesilahti", employees: personnelInfos?.hlokeskim_vesilahti } : null,
    personnelInfos?.hlokeskim_ylojarvi > 0 ? { name: "Ylöjärvi", employees: personnelInfos?.hlokeskim_ylojarvi } : null,
  ].filter(item => item)

  if (!municipalitiesWithEmployees?.length) {
    return null
  }

  const renderTitle = () => {
    if (allPersonnelInfos?.length === 1) {
      return `Kuntakohtaiset henkilöstötiedot ${
        personnelInfos?.tilinpaatos_vuosi ?
          personnelInfos?.tilinpaatos_vuosi :
          ""
      }`
    }
    return (
      <div className={Styles.title}>
        <h1>Kuntakohtaiset henkilöstötiedot</h1>
        <Select
          options={yearOptions}
          value={selectedYear}
          onChange={onChange}
          variant="borderless"
          valueAsObj
        />
      </div>
    )
  }

  return (
    <RibbonContainer title={renderTitle()}>
      <p className={Styles.infoText}>
        Huom. toimipaikkakohtaista henkilöstömäärää ei ole saatavilla.
      </p>
      <div className={Styles.personnelContainer}>
        <div className={Styles.row}>
          {municipalitiesWithEmployees.map((municipality) => (
            <Cell
              key={municipality.name}
              header={municipality.name}
              text={municipality.employees}
            />
          ))}
        </div>
      </div>
    </RibbonContainer>
  )
}

PersonnelInfos.propTypes = {
  allPersonnelInfos: PropTypes.arrayOf(PropTypes.shape()),
  yearOptions: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  selectedYear: PropTypes.shape().isRequired,
  onChange: PropTypes.func.isRequired,
}

export default PersonnelInfos
